__turbopack_context__.v({
  "helios-page-content": "iObPIG_helios-page-content",
  "helios-page-content__inner": "iObPIG_helios-page-content__inner",
  "helios-page-content__inner--full": "iObPIG_helios-page-content__inner--full",
  "helios-page-content__inner--md": "iObPIG_helios-page-content__inner--md",
  "helios-page-content__inner--sm": "iObPIG_helios-page-content__inner--sm",
});
